// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import styles from './form.module.less';
import {t_methods} from './types';
import cn from 'classnames';
// @ts-ignore
import {capitalize} from '/util/string.js';

interface i_method_button_props {
    children?: JSX.Element;
    type: t_methods;
    signup_mode: boolean;
    on_click: (type:t_methods)=>void;
}
export const Method_button = (props: i_method_button_props)=>{
    let login_with = 'Continue with';
    const is_toolip = location.host == 'toolip.io';
    const cls = is_toolip ?
      `${styles.auth_method} ${styles.auth_method_toolip}` :
      styles.auth_method;
    return <a className={cn(cls, styles[props.type])}
      onClick={()=>{
        props.on_click(props.type);
      }}>
      <div className={styles.auth_method_icon}>{props.children}</div>
      <div className={is_toolip && styles.auth_method_btn}>
        {login_with} {capitalize(props.type)}
      </div>
    </a>;
};
